// =============================================================================
// web/shims/react-native-device-info.js — WEB shim.
//
// Provides the small DeviceInfo surface services/app-config.ts + settings read
// (version/build/etc.). On web these come from the bundle-injected app metadata;
// values default gracefully. Native iOS resolves the real package untouched.
// =============================================================================
const APP_VERSION = '1.4.5'; // kept in sync with package.json version

const DeviceInfo = {
  getVersion: () => APP_VERSION,
  getBuildNumber: () => '0',
  getReadableVersion: () => `${APP_VERSION} (web)`,
  getBundleId: () => 'ai.cryb',
  getSystemName: () => 'Web',
  getSystemVersion: () => (typeof navigator !== 'undefined' ? navigator.userAgent : 'web'),
  getModel: () => 'Browser',
  getBrand: () => 'Web',
  getDeviceId: () => 'web',
  isTablet: () => false,
  getUniqueId: async () => 'web-unique-id',
  getUniqueIdSync: () => 'web-unique-id',
  getDeviceName: async () => 'Web Browser',
  getDeviceNameSync: () => 'Web Browser',
  hasNotch: () => false,
  isEmulator: async () => false,
  isEmulatorSync: () => false,
};

export const getVersion = DeviceInfo.getVersion;
export const getBuildNumber = DeviceInfo.getBuildNumber;
export const getReadableVersion = DeviceInfo.getReadableVersion;
export const getBundleId = DeviceInfo.getBundleId;
export const getUniqueId = DeviceInfo.getUniqueId;
export const getUniqueIdSync = DeviceInfo.getUniqueIdSync;

export default DeviceInfo;
